import React from 'react';
import { Controller } from 'react-hook-form';
import { Control, Field, Input, Label } from 'components/UIComponents/Form';
import ValidationError from 'components/FormControls/ValidationError';
import { useTranslation } from 'react-i18next';
import { NO_WHITESPACE_REGEX } from 'utils/constants/formConstants';

export default ({ name, control, errors }) => {
  const { t } = useTranslation();

  return (
    <Field>
      <Control>
        <Label
          required
          hint={t(
            'datagate.external.blackBox.fileUpload.form.registryCode.hint'
          )}
          htmlFor={name}
        >
          {t('datagate.external.blackBox.fileUpload.form.registryCode.label')}
        </Label>
        <Controller
          as={
            <Input
              id={name}
              placeholder={t(
                'datagate.external.blackBox.fileUpload.form.registryCode.placeholder'
              )}
              maxLength="200"
            />
          }
          rules={{
            required: t(
              'datagate.external.blackBox.fileUpload.form.registryCode.required'
            ),
            pattern: {
              value: NO_WHITESPACE_REGEX,
              message: t(
                'datagate.external.blackBox.fileUpload.form.registryCode.required'
              ),
            },
          }}
          name={name}
          control={control}
        />
      </Control>
      <ValidationError name={name} errors={errors} />
    </Field>
  );
};
